// extracted by css-extract-rspack-plugin
export default {"block":"ZSbWV","jar":"PtdM9","text":"rTkJL","title":"zjDdu","lead":"DHrm8","authorized":"TnzoK","jar-shake":"Du0Km","jarShake":"Du0Km"};